<script>
import CustomersApi from "@/services/customers-api";
import CampaignApi from "@/services/campaign-api";


export default {
    props : {
        campaign:{
          type:Object,
          default: () => null,
      },
  
    },
  data() {
    return {
        settingsCampaign: {id:null ,
                    name:null,
                    start:null,
                    size:null, 
                    end:null,
                    sector:[],
                    customer:null,
                    quantityBag:null,
                    quantityColor:null,
                    description:null,
                    campaignWithOutBags:true,
                    isMenuCampaign:true,
                    isMenuCampaignWithOrder:null },
        customersList:[],
        sectorsList:null,
        selectedSector: null,
        quantityColor: 4 ,
        bagSizeList:null,
        menuCampaignMode: null,

    };
  },
  mounted() {
    this.getCustomers()
    this.getSector()
    this.getBagSize()



  },

  watch:{

    campaign: function(){
        if(this.campaign){
        this.settingsCampaign = this.campaign
        this.menuCampaignMode = this.settingsCampaign.isMenuCampaignWithOrder ? "order" : this.settingsCampaign.isMenuCampaignWithQuote ? "quote" : "standard";
    }
    },

    menuCampaignMode(newValue) {
        if (!this.settingsCampaign) return;

        this.settingsCampaign.isMenuCampaignWithOrder = false;
        this.settingsCampaign.isMenuCampaignWithQuote = false;

        if (newValue === "order") {
            this.settingsCampaign.isMenuCampaignWithOrder = true;
        } else if (newValue === "quote") {
            this.settingsCampaign.isMenuCampaignWithQuote = true;
        }
    }

  },
  

  methods: {

    saveSettingsCampain(){      

        const settingsCampaign = {
            id : this.settingsCampaign.id,
            name : this.settingsCampaign.name,
            start : this.settingsCampaign.start,
            end : this.settingsCampaign.end,
            sizeBag : this.settingsCampaign.bagSizeDTO == null ? null : this.settingsCampaign.bagSizeDTO.code ,
            customerId : this.settingsCampaign.customer == null ? null :this.settingsCampaign.customer.id,
            quantityBag : this.settingsCampaign.quantityBag,
            quantityColor : this.settingsCampaign.quantityColor,
            dateSupervisoryAssistance : this.settingsCampaign.dateSupervisoryAssistance,
            dateStartPrintDate : this.settingsCampaign.dateStartPrintDate,
            dateEndPrintDate : this.settingsCampaign.dateEndPrintDate,
            avgDistributedCount : this.settingsCampaign.avgDistributedCount,
            campaignWithOutBags : this.settingsCampaign.campaignWithOutBags,
            isMenuCampaign : this.settingsCampaign.isMenuCampaign,
            isMenuCampaignWithOrder : this.settingsCampaign.isMenuCampaignWithOrder,
            isMenuCampaignWithQuote : this.settingsCampaign.isMenuCampaignWithQuote,

        }

        CampaignApi.saveSettingsCampain(settingsCampaign).then(result =>{
            if(result){
                this.settingsCampaign = result
                if(this.campaign == null || this.campaign.id == null ){
                    this.$router.push({ 
                    path: "/campaign/details", 
                    query: { campaignId: result.id } 
                });
                }
                 this.$emit('refreshId' , result.id);
                 this.$store.dispatch("menu/setStateFromCampaign", this.settingsCampaign);
            }
        })
    },

    getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
    },

    selectSector(sector) {

        if (!Array.isArray(this.settingsCampaign.sector)) {
        this.settingsCampaign.sector = [];
        }

        const index = this.settingsCampaign.sector.indexOf(sector);

        if (index === -1) {
        this.settingsCampaign.sector.push(sector);
        } else {
        this.settingsCampaign.sector.splice(index, 1);
        }

        },


        getSector(){
        CampaignApi.getSector().then(sector =>{
            if(sector){
                this.sectorsList = sector
            }
        })
        },

        getBagSize(){
        CampaignApi.getBagSize().then(result =>{
            if(result){
                this.bagSizeList = result
            }
        })
        },

    },
};

</script>

<template>

    <div>

        <div class="row">
            <div class="col-md-8 col-12">
                <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('campaign.card.settings')}} </h2>
            </div>

            <div class="col-md-4 col-12 mt-md-0 mt-2 text-right">
                <b-button variant="primary" @click="saveSettingsCampain()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 font-weight-bold text-uppercase">
                    {{$t("buttons.save")}}
        </b-button>
            </div>
        </div>
        

        

        <div class="row mt-5">

            <div class="col-12 pr-lg-2">
                <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('campaign.label.name')}} </div>
                    <b-form-group   class="font-weight-bold font-size-14"   >
                        <b-input-group   >
                            <b-form-input  :placeholder="$t('campaign.input.name')"   
                            v-model="settingsCampaign.name" ></b-form-input>                              
                        </b-input-group>
                    </b-form-group>
            </div>
            <div  v-if="customersList && customersList.length" class="col-12 pr-lg-2 ">
                <div class="text-dark font-size-16 pt-2 pb-2 "> {{$t('campaign.label.customer')}} </div>
                <div>
                    <b-form-group class="font-weight-bold font-size-14"  label-for="">
                        <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="name" v-model="settingsCampaign.customer">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>
        </div>

        <div class="text-dark font-size-16 pt-3 pb-2 "> {{$t('campaign.label.menuType')}} </div>

        <div v-if="settingsCampaign && settingsCampaign.isMenuCampaign" class="row ml-2 mt-2">

            <div class="col-md-4 col-12">
                <div class="form-group m-0">
                    <b-form-radio
                        v-model="menuCampaignMode"
                        value="standard"
                        class="custom-radio custom-radio-success mb-0 mt-0"
                    >
                        {{ $t("menuOrder.standardMenu") }}
                    </b-form-radio>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="form-group m-0">
                    <b-form-radio
                        v-model="menuCampaignMode"
                        value="order"
                        class="custom-radio custom-radio-success mb-0 mt-0"
                    >
                        {{ $t("menuOrder.activateOrder") }}
                    </b-form-radio>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="form-group m-0">
                    <b-form-radio
                        v-model="menuCampaignMode"
                        value="quote"
                        class="custom-radio custom-radio-success mb-0 mt-0"
                    >
                        {{ $t("menuOrder.quoteRequest") }}
                    </b-form-radio>
                </div>
            </div>
        </div>


        
       
        <div class="row mt-3">
            
            <div class="col-lg-6 col-md-6  pr-md-3 pr-0">
                <b-form-group  class="text-dark font-size-14" :label="$t('campaign.input.startDate')">
                <b-form-datepicker
                    v-model="settingsCampaign.start"
                    locale="fr"
                    :label-no-date-selected="$t('campaign.input.startDate')"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright
                    hide-header
                ></b-form-datepicker>
                </b-form-group>
            </div>
            <div class="col-lg-6 col-md-6  pr-md-3 pr-0">
                <b-form-group class="text-dark font-size-14" :label="$t('campaign.input.endDate')" >
                <b-form-datepicker
                    v-model="settingsCampaign.end"
                    locale="fr"
                    :label-no-date-selected="$t('campaign.input.endDate')"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright                         
                    hide-header
                ></b-form-datepicker>
                </b-form-group>
                
            </div> 
        </div>




        
    </div>


    
</template>
  
<style scoped>
.img-fluid {
  border-radius: 10px;
  border: 4px solid #d3d3d3; 
  cursor: pointer;
  transition: border 0.3s ease-in-out;
}

.selected img {
  border-color: #1d3266; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>
